import { render, staticRenderFns } from "./FilesInput.vue?vue&type=template&id=11a48ebf"
import script from "./FilesInput.vue?vue&type=script&lang=js"
export * from "./FilesInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports